import React from "react";

interface AuthModalHeaderProps {
  mode: "login" | "signup";
}

const AuthModalHeader: React.FC<AuthModalHeaderProps> = ({ mode }) => {
  return (
    <>
      {/* Logo */}
      <div className="mb-6 flex justify-center">
        <div className="w-16 h-16 bg-gradient-to-br from-holo-blue to-deep-indigo rounded-full flex items-center justify-center relative">
          <span className="text-white font-bold text-2xl">🦙</span>
          <div className="absolute top-1 right-1 w-3 h-3 bg-electric-yellow rounded-full border border-deep-indigo"></div>
        </div>
      </div>

      <h2 className="text-2xl font-bold font-poppins mb-2 text-center">
        ThePokeLlama
      </h2>

      <p className="text-lg text-white/80 font-inter text-center">
        {mode === "signup"
          ? "Create your free PokéLlama account"
          : "Welcome back to PokéLlama"}
      </p>
    </>
  );
};

export default AuthModalHeader;
